<c-card *transloco="let t">
    <c-card-body class="px-2">


        <app-worker-reports-menu></app-worker-reports-menu>

        <div class="row">
          <div class="col-sm-8">
            <h3>{{ t('Report: Actions Stats') }}</h3>
            <p>{{ t('Graphs showing shift actions, also available for export') }}</p>
          </div>
          <div class="col-sm-4 text-end">
            <button type="button" class="btn btn-light mb-2" (click)="switchView()">
              <i class="fa-solid" [ngClass]="viewMode === 'table' ? 'fa-chart-bar' : 'fa-table'"></i>
              {{ viewMode === 'table' ? t('View Graphs') : t('View Table') }}
            </button>
            <button type="button" class="btn btn-light mb-2" (click)="export()">
              <i class="fa-solid fa-file-excel"></i> {{ t('Export Report') }}
            </button>
          </div>
        </div>

          <div class="card mb-2">
            <div class="card-header" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="true" aria-controls="collapseExample">
              <i class="fa-solid fa-chevron-down"></i> {{ t('Filter Results') }}
            </div>
            <div class="show" id="collapseExample">
              <div class="card-body">

                <form cForm >
                  <div class="row mb-2 d-flex justify-content-center">
                    <div class="col-sm-6">
                      <c-input-group>
                        <span cInputGroupText><svg cIcon name="cil-calendar"></svg>&nbsp;&nbsp; {{ t('Dates') }}</span>
                        <input type="text" ngxDaterangepickerMd  [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="selected" name="datetime"  class="form-control"/>
                      </c-input-group>
                    </div>
                  </div>
                  <div class="row d-flex justify-content-center mb-2">
                      <label  class="col-sm-2 col-form-label text-end"  for="monitors">
                        <b>{{ t('Monitor') }}</b>
                      </label>
                      <div class="col-sm-4">
                        <ng-select
                        [items]="monitors"
                        name="monitor"
                        [(ngModel)]="monitor"
                        bindLabel="name"
                        bindValue="id">
                        </ng-select>
                      </div>

                      <ng-container *ngIf="okService.groups?.length > 0 && okService.hasFeature('groups')">
                        <label  class="col-sm-2 col-form-label text-end" for="groups">
                          <b>{{ t('Group') }}</b>
                        </label>
                      <div class="col-sm-4">
                        <ng-select
                        [items]="groups"
                        name="group"
                        [(ngModel)]="group"
                        bindLabel="name"
                        bindValue="id">
                        </ng-select>
                      </div>
                    </ng-container>

                    </div>
                  <div class="row d-flex justify-content-center mb-2">
                    <div class="col-sm-3 d-flex justify-content-end">
                      <button cButton class="btn btn-info text-white" type="submit"  (click)="updateFilter()">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        <span class="d-none d-lg-inline">
                          {{ t('Search') }}
                        </span>
                      </button>
                    </div>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                    <div class="col-sm-3">
                      <button cButton class="btn btn-light" type="submit"  (click)="clearFilter()">
                        <i class="fa-solid fa-xmark"></i>
                        <span class="d-none d-lg-inline">
                          {{ t('Clear Filter') }}
                        </span>
                      </button>
                    </div>
                </div>

                </form>

              </div>
            </div>
          </div>


          <div *ngIf="viewMode === 'table' && workers.length > 0" class="mb-2">
            <div class="d-flex justify-content-end mb-2">
              <button type="button" class="btn btn-sm" [ngClass]="activeOnly ? 'btn-info text-white' : 'btn-outline-secondary'" (click)="activeOnly = !activeOnly">
                <i class="fa-solid fa-filter"></i>
                {{ activeOnly ? t('View all Workers') : t('View only Workers with Shifts') }}
              </button>
            </div>
            <div class="table-responsive">
              <table class="table table-striped table-hover table-bordered mb-0">
                <thead class="table-light">
                  <tr>
                    <th style="cursor:pointer;white-space:nowrap" (click)="sortBy('name')">
                      {{ t('Name') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'name' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                    <th style="cursor:pointer;white-space:nowrap" (click)="sortBy('pin')">
                      {{ t('PIN') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'pin' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="text-end" style="cursor:pointer;white-space:nowrap" (click)="sortBy('Hours')">
                      {{ t('Hours') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'Hours' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="text-end" style="cursor:pointer;white-space:nowrap" (click)="sortBy('Shifts')">
                      {{ t('Shifts') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'Shifts' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="text-end" style="cursor:pointer;white-space:nowrap" (click)="sortBy('Check Ins')">
                      {{ t('Check Ins') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'Check Ins' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="text-end" style="cursor:pointer;white-space:nowrap" (click)="sortBy('High Risk Check Ins')">
                      {{ t('High Risk') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'High Risk Check Ins' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="text-end" style="cursor:pointer;white-space:nowrap" (click)="sortBy('Timed Activities')">
                      {{ t('Timed Act.') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'Timed Activities' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="text-end" style="cursor:pointer;white-space:nowrap" (click)="sortBy('Total Alerts')">
                      {{ t('Total Alerts') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'Total Alerts' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="text-end" style="cursor:pointer;white-space:nowrap" (click)="sortBy('Alert Help')">
                      {{ t('Help') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'Alert Help' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="text-end" style="cursor:pointer;white-space:nowrap" (click)="sortBy('Alert Missed Check In')">
                      {{ t('Missed CI') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'Alert Missed Check In' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="text-end" style="cursor:pointer;white-space:nowrap" (click)="sortBy('Alert Missed High Risk')">
                      {{ t('Missed HR') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'Alert Missed High Risk' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="text-end" style="cursor:pointer;white-space:nowrap" (click)="sortBy('Alert Man Down')">
                      {{ t('Man Down') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'Alert Man Down' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="text-end" style="cursor:pointer;white-space:nowrap" (click)="sortBy('Alert Timed Activity')">
                      {{ t('Timed Act. Alert') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'Alert Timed Activity' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="text-end" style="cursor:pointer;white-space:nowrap" (click)="sortBy('Alert Other')">
                      {{ t('Other') }}
                      <i class="fa-solid" [ngClass]="sortColumn === 'Alert Other' ? (sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort text-muted'"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let worker of filteredWorkers">
                    <td><b>{{ worker.name }}</b></td>
                    <td>{{ u.formatWorkerPin(worker.pin) }}</td>
                    <!-- <td>{{ worker.email }}</td>
                    <td>{{ worker.monitors }}</td> -->
                    <td class="text-end">{{ worker['Hours'] }}</td>
                    <td class="text-end">{{ worker['Shifts'] }}</td>
                    <td class="text-end">{{ worker['Check Ins'] }}</td>
                    <td class="text-end">{{ worker['High Risk Check Ins'] }}</td>
                    <td class="text-end">{{ worker['Timed Activities'] }}</td>
                    <td class="text-end">{{ worker['Total Alerts'] }}</td>
                    <td class="text-end">{{ worker['Alert Help'] }}</td>
                    <td class="text-end">{{ worker['Alert Missed Check In'] }}</td>
                    <td class="text-end">{{ worker['Alert Missed High Risk'] }}</td>
                    <td class="text-end">{{ worker['Alert Man Down'] }}</td>
                    <td class="text-end">{{ worker['Alert Timed Activity'] }}</td>
                    <td class="text-end">{{ worker['Alert Other'] }}</td>
                  </tr>
                </tbody>
                <tfoot class="table-light">
                  <tr>
                    <th><b>{{ t('Totals') }}</b></th>
                    <th></th>
                    <th class="text-end"><b>{{ getTotal('Hours') }}</b></th>
                    <th class="text-end"><b>{{ getTotal('Shifts') }}</b></th>
                    <th class="text-end"><b>{{ getTotal('Check Ins') }}</b></th>
                    <th class="text-end"><b>{{ getTotal('High Risk Check Ins') }}</b></th>
                    <th class="text-end"><b>{{ getTotal('Timed Activities') }}</b></th>
                    <th class="text-end"><b>{{ getTotal('Total Alerts') }}</b></th>
                    <th class="text-end"><b>{{ getTotal('Alert Help') }}</b></th>
                    <th class="text-end"><b>{{ getTotal('Alert Missed Check In') }}</b></th>
                    <th class="text-end"><b>{{ getTotal('Alert Missed High Risk') }}</b></th>
                    <th class="text-end"><b>{{ getTotal('Alert Man Down') }}</b></th>
                    <th class="text-end"><b>{{ getTotal('Alert Timed Activity') }}</b></th>
                    <th class="text-end"><b>{{ getTotal('Alert Other') }}</b></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div *ngIf="viewMode === 'graphs'">
            <div class="card mb-2">
              <div class="card-header d-flex justify-content-between align-items-center">
                <span><b>Shifts per Worker</b></span>
                <button class="btn btn-sm btn-light" (click)="downloadChart('chartShifts', 'shifts-per-worker')">
                  <i class="fa-solid fa-download"></i>
                </button>
              </div>
              <div class="card-body">
                <div [style.height.px]="Math.max(300, filteredWorkers.length * 30)">
                  <canvas id="chartShifts"></canvas>
                </div>
              </div>
            </div>

            <div class="card mb-2">
              <div class="card-header d-flex justify-content-between align-items-center">
                <span><b>Alert Breakdown per Worker</b></span>
                <button class="btn btn-sm btn-light" (click)="downloadChart('chartAlerts', 'alert-breakdown-per-worker')">
                  <i class="fa-solid fa-download"></i> {{ t('Download') }}
                </button>
              </div>
              <div class="card-body">
                <div [style.height.px]="Math.max(300, filteredWorkers.length * 30)">
                  <canvas id="chartAlerts"></canvas>
                </div>
              </div>
            </div>

            <div class="card mb-2">
              <div class="card-header d-flex justify-content-between align-items-center">
                <span><b>Alert Type Distribution</b></span>
                <button class="btn btn-sm btn-light" (click)="downloadChart('chartDoughnut', 'alert-type-distribution')">
                  <i class="fa-solid fa-download"></i> {{ t('Download') }}
                </button>
              </div>
              <div class="card-body">
                <div style="height:400px">
                  <canvas id="chartDoughnut"></canvas>
                </div>
              </div>
            </div>
          </div>

    </c-card-body>
  </c-card>

